module.exports = __webpack_public_path__ + "media/images/application/template/boxplus/icon--rosette-4665d6ed958cabe5166a4a723bb49c00.svg";